import getBrowserLanguage from "browser-locale";
import { DEFAULT_LANG, LANG_SETTINGS, LANGS } from "../constants";

export const getLangFromLocale = locale =>
  locale.replace(/-\w{2}$/, "").toLowerCase();

export const getDefaultLang = () => {
  const browserLocale = getBrowserLanguage();
  const browserLang = getLangFromLocale(browserLocale);

  if (browserLang in LANGS) {
    return browserLang;
  }

  return DEFAULT_LANG;
};

export const getCurrencyByLang = lang => LANG_SETTINGS[lang].currency;

export const getSubscriptionAmountByLang = lang =>
  LANG_SETTINGS[lang].subscriptionAmount;

export const formatCurrencyByLang = (amount, lang) => {
  const settings = LANG_SETTINGS[lang];
  return `${settings.currencyPrefix || ""}${amount}${settings.currencySuffix ||
    ""}`;
};



// WEBPACK FOOTER //
// ./src/helpers/locale.js